<script>
import availableFilters from './availableFilters';
import { TFilterCollection } from '~/components/Filters';

export default {
  extends: TFilterCollection,

  props: {
    availableFilters: {
      type: Array,
      default: () => availableFilters,
    },
  },
};
</script>
